import { render, staticRenderFns } from "./PlayerElement.vue?vue&type=template&id=593de31c&scoped=true"
import script from "./PlayerElement.vue?vue&type=script&lang=js"
export * from "./PlayerElement.vue?vue&type=script&lang=js"
import style0 from "./PlayerElement.vue?vue&type=style&index=0&id=593de31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593de31c",
  null
  
)

export default component.exports